/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-10T17:00:05.815
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinancialSettlementItem,
	getFinancialSettlementItemCreateInit,
	getFinancialSettlementItemEditInit,
	getFinancialSettlementItemView,
	deleteFinancialSettlementItem
} from '@api/financial/FinancialSettlementItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancialSettlementItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialSettlementItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialSettlementItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialSettlementItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialSettlementItem({}, FinancialSettlementItem) {
			return new Promise((resolve, reject) => {
				saveFinancialSettlementItem(FinancialSettlementItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialSettlementItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialSettlementItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialSettlementItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialSettlementItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
